import { ApiClient } from '@travel/api-client';

import { CurrencyItems } from 'SupplierCurrencies-Types';

export const fetchCurrencyList = (http: ApiClient): Promise<CurrencyItems> =>
  http.get('/world-api/currencies').catch(error => error);
